import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Reply = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.94188 3.21374C6.67295 2.5849 7.80484 3.10431 7.80484 4.06862V5.25466C10.0082 5.28776 11.5419 5.96354 12.5342 7.20097C13.5732 8.4967 13.9163 10.29 13.9991 12.2057C14.0191 12.6676 13.6861 12.9743 13.3448 13.0445C13.0107 13.1132 12.5989 12.9728 12.4178 12.5698C11.6515 10.8654 11.0126 10.0827 10.3166 9.68317C9.6975 9.32778 8.95237 9.22403 7.80484 9.20156V10.3104C7.80484 11.2861 6.64956 11.8013 5.92366 11.1492L2.37408 7.96068C1.86808 7.50615 1.87664 6.71047 2.39229 6.26693L5.94188 3.21374ZM6.55192 4.34165L3.31739 7.12385L6.55192 10.0294V8.67008C6.55192 8.25884 6.88878 7.94273 7.28109 7.94348C8.70663 7.94624 9.90554 8.00254 10.9404 8.59655C11.5227 8.9308 12.0209 9.41465 12.4853 10.0827C12.2957 9.23937 11.9981 8.53517 11.5567 7.98477C10.8094 7.05281 9.54888 6.4436 7.30357 6.51136C6.91469 6.5231 6.55192 6.21578 6.55192 5.78466V4.34165Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Reply;
